import { Component, computed, inject, input, viewChild } from '@angular/core';
import { UiButtonComponent, UiNumberComponent } from '@design-system';
import { BottomSheetComponent } from '../../../../components/bottom-sheet/bottom-sheet.component';
import { MASKED_VALUE } from '../../../../models/masked-value.model';
import { WalletStore } from '../../data-access/wallet.store';
import { OTHER_WALLETS } from '../../domain/other-wallets.constants';

/** The commodity wallets' balances, opened from the card's «سایر». */
@Component({
	selector: 'app-other-wallets-bottom-sheet',
	imports: [BottomSheetComponent, UiButtonComponent, UiNumberComponent],
	templateUrl: './other-wallets-bottom-sheet.component.html',
	host: { 'data-cy': 'other-wallets-bottom-sheet' }
})
export class OtherWalletsBottomSheetComponent {
	private readonly walletStore = inject(WalletStore);
	private readonly sheet = viewChild<BottomSheetComponent>('sheet');

	readonly amountsHidden = input(false);
	readonly maskedValue = MASKED_VALUE;

	readonly wallets = computed(() =>
		OTHER_WALLETS.map(wallet => ({ ...wallet, balance: this.walletStore.wallets()[wallet.key].balance }))
	);

	/** Opens on the figures already read and refreshes them from the summary meanwhile. */
	open(): Promise<void> {
		this.walletStore.load();
		return this.sheet()?.open() ?? Promise.resolve();
	}

	close(): void {
		this.sheet()?.close();
	}
}
